import { createFileRoute } from "@tanstack/react-router"

import { FlagsTab } from "~/features/feature-flags/pages"

export const Route = createFileRoute("/_auth/internal/feature-flags/_overview/")({
  component: FlagsTab,
})
